import {
  faFile,
  faMountainSun,
  faMusic,
  faVideo,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { fileIsModel } from "@/utils/libraryObjectUtils";

import { File } from "../graphql/schema.graphql";
import { SafetensorsIcon } from "../ui-v2/icons";

export function fileIcon(file: Pick<File, "contentType" | "name">) {
  if (file.contentType?.startsWith("image/")) {
    return <FontAwesomeIcon icon={faMountainSun} />;
  } else if (file.contentType?.startsWith("audio/")) {
    return <FontAwesomeIcon icon={faMusic} />;
  } else if (file.contentType?.startsWith("video/")) {
    return <FontAwesomeIcon icon={faVideo} />;
  } else if (fileIsModel(file)) {
    return <SafetensorsIcon />;
  } else {
    return <FontAwesomeIcon icon={faFile} />;
  }
}
